const Actions = {
  Navigate: {
    DO: 'v.uwv-decisions.actions.navigate.do'
  },
  Tabs: {
    OPEN: 'v.uwv-decisions.actions.tabs.open',
    CLOSE: 'v.uwv-decisions.actions.tabs.close',

    New: {
      OPEN: 'v.uwv-decisions.actions.tab.open-new',
      CLOSE: 'v.uwv-decisions.actions.tab.close-new'
    }
  }
};

const Mutations = {
  CLEAR: 'v.uwv-decisions.mutations.clear',
  ActiveView: {
    SET: 'v.uwv-decisions.mutations.active-view.set'
  },
  Tabs: {
    ADD: 'v.uwv-decisions.mutations.tabs.add',
    OPEN: 'v.uwv-decisions.mutations.tabs.open',
    CLOSE: 'v.uwv-decisions.mutations.tabs.close'
  }
};

const Views = {
  Index: 'v.uwv-decisions.views.index',
  New: 'v.uwv-decisions.views.new'
};

export default {
  Actions,
  Mutations,
  Views
};
